import { useContext } from 'react';
import DiscountContext from '~/context/common/DiscountContext';
import useKeyWithInterval from '~/hooks/common/useKeyWithInterval';
import formatAndDropDecimal from '~/utilities/formatAndDropDecimal';
import { StyledPrice } from './Price.styles';

type OwnProps = {
  creditKarmaPromoAmount: number;
  price: number;
};

export default function PriceWithCreditKarmaPromo({
  creditKarmaPromoAmount,
  price
}: OwnProps) {
  const priceKey = useKeyWithInterval();
  const { totalDiscount } = useContext(DiscountContext);
  const finalPrice = price - totalDiscount;

  return price ? (
    <div className="grid items-end gap-x-4">
      <div className="text-grey-5 line-through tl-body-s m:tl-body-m">
        ${formatAndDropDecimal(finalPrice + creditKarmaPromoAmount)}
      </div>
      <StyledPrice key={priceKey}>
        ${formatAndDropDecimal(finalPrice)}
        <span className="tl-body-s m:tl-body-m">
          {' '}
          with ${creditKarmaPromoAmount} savings
        </span>
      </StyledPrice>
    </div>
  ) : null;
}
